export default __webpack_public_path__ + "static/about-us-image-l4-1-73a54b2fc337b15acd357f42c7395386.png";